/**
 * Avondale Golf Club — Hayden Lake, ID.
 *
 * Played by the tournament in 2024 and 2025. Unlike every other card in this
 * app, this one is transcribed from a PHOTOGRAPH OF THE GROUP'S OWN 2024
 * SCORECARD, not from a scorecard database. The databases are used here only
 * as a check on the transcription, and they confirm it.
 *
 * The photographed card heads its front-nine yardage column "Blue" and its
 * back-nine column "Green". That is a printing quirk of the card, not two tee
 * sets: the two columns sum to a single 6563-yard round (3181 out, 3382 in),
 * and it is modelled here as ONE tee set of 6563 yards. Nothing was
 * invented to fill a second column.
 *
 * Par 72 — 35 out, 37 in.
 */

import { tees, type Seed } from '../card'

export const AVONDALE: Seed = {
  id: 'avondale',
  name: 'Avondale Golf Club',
  par: 72,
  pars: [4, 3, 4, 4, 4, 4, 5, 3, 4, 4, 4, 3, 5, 3, 4, 4, 5, 5],
  si: [3, 17, 15, 1, 5, 9, 13, 7, 11, 8, 2, 16, 6, 18, 12, 14, 4, 10],
  yards: [
    [397, 125, 298, 413, 414, 412, 506, 217, 399, 364, 455, 174, 493, 104, 345, 314, 566, 567],
  ],
  tees: tees([['blue', 'Blue/Green (card)', 71.4, 124, 6563]]),
  provenance:
    'The only card in this app taken from the physical article: a photograph of ' +
    "the group's own 2024 Avondale scorecard. Every par, stroke index and " +
    'yardage below is read straight off that photograph. It is internally ' +
    'consistent — the nines sum to 3181 and 3382 for 6563, par 35 and 37 for ' +
    '72, and the stroke index is a clean permutation of 1-18 with the odds on ' +
    'the front and the evens on the back. ' +
    'Par and stroke index are then confirmed three times over, independently and ' +
    'cell for cell, by bluegolf, golfify and mscorecard: 3-17-15-1-5-9-13-7-11 ' +
    'out, 8-2-16-6-18-12-14-4-10 in. This is the best-corroborated stroke index ' +
    'in the app. ' +
    'The yardages are the photograph, not the databases, because the databases ' +
    'disagree with it slightly and with each other: bluegolf prints 6546 total ' +
    'and golfify 6614, and the per-hole gaps cluster on holes 6, 7, 8, 10, 11, ' +
    '15 and 17 (bluegolf has 410/502/215/359/452/348/562 against the card\'s ' +
    "412/506/217/364/455/345/566). Those look like different measurement years " +
    'of the same holes rather than a transcription error in either. The card the ' +
    'group actually played wins. ' +
    'RATING AND SLOPE ARE THE WEAK FIELD AND NO SOURCE STATES THEM FOR A ' +
    '6563-YARD TEE. The rating 71.4 is agreed by golfnow and golfify. The slope ' +
    'is not agreed: golfnow says 124 at 6571 yards, golfify says 126 at 6614, ' +
    'bluegolf says 130 at 6546. 124 is used here only because golfnow\'s 6571 is ' +
    'the closest published yardage to the 6563 on the card — that is a tiebreak, ' +
    'not a confirmation, and a slope wrong by six moves every course handicap. ' +
    'Read the plate on the first tee before anyone is given a stroke. ' +
    'Ignore golflink and golfpass on this course entirely: both report Avondale ' +
    'as par 74, 6573 yards, 77.8/142. That is a women\'s tee record mislabelled ' +
    "as the men's card, and it contradicts the photograph, bluegolf, golfify, " +
    'golfnow and mscorecard, all of which say par 72.',
}
